<template>
  <div class='edit-customer-company-profile-form'>
    <v-form ref="form" v-model='validValue'>
      <v-text-field
        dense
        outlined
        type='text'
        v-model="value.name"
        :rules="[rules.required, rules.organizationNotExists]"
        class="organization-name"
        :label="$t('organization.info.name.label')"
        :placeholder="$t('organization.info.name.placeholder')"
      />
      <v-autocomplete
        :items="industries"
        :label="$t('registration.workspace.info.industry')"
        :placeholder="$t('registration.workspace.info.industry.placeholder')"
        v-model="value.industry"
        item-value="id"
        dense
        outlined
        return-object
      />
      <v-autocomplete
        :items="amountOfEmployees"
        :label="$t('registration.workspace.info.employees')"
        :placeholder="$t('registration.workspace.info.employees.placeholder')"
        item-value="amount"
        v-model="value.amountOfEmployees"
        dense
        outlined
        return-object
      />
      <v-autocomplete
        :items="regions"
        :label="$t('registration.workspace.info.office.location')"
        :placeholder="$t('registration.workspace.info.office.location.placeholder')"
        v-model="value.region"
        item-value="id"
        dense
        outlined
        return-object
      />
      <div class="column-inner-title">
        {{ $t('registration.workspace.info.regulation.title') }}
      </div>
      <v-autocomplete
        class="regulations"
        :items="regulations"
        :label="$t('registration.workspace.info.regulations')"
        :placeholder="$t('registration.workspace.info.regulations.placeholder')"
        v-model="value.regulations"
        item-value="id"
        dense
        outlined
        multiple
        clearable
        return-object
      >
        <template slot="selection" slot-scope="data">
          <regulations-selection
            :text="$t(`${data.item.shortName}.shortName`).toString()"
            :isLastElement="value.regulations.findIndex(reg => reg.id === data.item.id) === value.regulations.length - 1"
          />
        </template>
      </v-autocomplete>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { rules } from '@/utils/validationUtils';
import RegulationsSelection from '@/components/registration/RegulationsSelection.vue';

export default {
  name: 'EditCompanyCustomerProfileForm',
  components: {
    RegulationsSelection,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    valid: {
      required: false,
      default: false,
      type: Boolean,
    },
    newOrganization: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters([
      'companyCustomerFullRegionsOptions',
      'companyCustomerFullIndustriesOptions',
      'companyCustomerFullRegulationsOptions',
      'registrationAmountOfEmployees',
      'organizations',
    ]),
    existOrganizationsNames() {
      return this.organizations.map(org => org.name);
    },
    validValue: {
      set(val) {
        this.$emit('updateValid', val);
      },
      get() {
        return this.valid;
      },
    },
    regions() {
      return this.companyCustomerFullRegionsOptions.map(region => ({ text: this.$t(`${region.name}`), ...region }));
    },
    industries() {
      return this.companyCustomerFullIndustriesOptions.map(industry => ({ text: this.$t(`${industry.name}`), ...industry }));
    },
    regulations() {
      return this.companyCustomerFullRegulationsOptions.map(regulation => ({
        text: this.$t(`${regulation.shortName}.shortName`),
        ...regulation,
      }));
    },
    amountOfEmployees() {
      return this.registrationAmountOfEmployees.map(amount => ({
        text: this.$pt('registration.workspace.info.amount.of.employees', amount),
        amount,
      }));
    },
    rules() {
      return {
        ...rules,
        required: v => rules.required(v) || this.$t('required'),
        organizationNotExists: v => !!this.isOrganizationNameValid(v),
      };
    },
  },
  methods: {
    isOrganizationNameValid(v) {
      return (this.newOrganization && !this.existOrganizationsNames.includes(v)) || !this.newOrganization;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.edit-customer-company-profile-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: $font-family-regular;
  .column-inner-title {
    margin-top: $space-9;
    margin-bottom: $space-6;
  }
  .regulations {
    margin-top: $space-2;
  }
}
</style>
<style lang="scss">
.edit-customer-company-profile-form {
  z-index: 10;
  .v-input__icon--append {
    padding-bottom: 2px;
  }
  .v-select__selections{
    margin-left: 5px;
  }
  .v-text-field__slot {
    background-color: var(--bg-tertiary);
    box-shadow: none;
  }
}
</style>
